import React from 'react';
import './Sidebar.css';

function Sidebar({ components, currentComponent, onComponentSelect }) {
  const grouped = components.reduce((acc, comp) => {
    if (!acc[comp.category]) acc[comp.category] = [];
    acc[comp.category].push(comp);
    return acc;
  }, {});

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h3>Components</h3>
      </div>
      
      <div className="sidebar-content">
        {Object.entries(grouped).map(([category, comps]) => (
          <div key={category} className="category">
            <h4 className="category-title">{category}</h4>
            <ul className="component-list">
              {comps.map((comp) => (
                <li key={comp.id}>
                  <button
                    className={`comp-link ${currentComponent?.id === comp.id ? 'active' : ''}`}
                    onClick={() => onComponentSelect(comp)}
                  >
                    {comp.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </aside>
  );
}

export default Sidebar;
